import { lenderService } from "@/modules/contacts/features/lender/store/services/lender-service";
import { LENDER_LOAN_BEST_MATCH_HEATMAP_SERVICE_TAG } from "@/modules/contacts/features/lender/utils/lender-service-tags";

const getLenderLoanHeatMap = lenderService.injectEndpoints({
  endpoints: builder => ({
    getLenderLoanHeatMap: builder.query({
      query: ({ loanId, lenderId }) => `lenders/${lenderId}/heatmap/${loanId}`,
      providesTags: (result, error, { lenderId: id }) => [
        { type: LENDER_LOAN_BEST_MATCH_HEATMAP_SERVICE_TAG, id },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLenderLoanHeatMapQuery } = getLenderLoanHeatMap;

